import BaseService from "./BaseService";
import axiosInstance from "./axiosConfig";

class OrderService {
  static async getOrders(id, password, token, page = 1, pageSize = 10, filters = {}, config = {}) {
    try {
      if (password) {
        return await axiosInstance.post(`orders/${id}/access`, { accessCode: password });
      }
      else if (id) {
        return await BaseService.get(`orders/${id}`, token);
      }

      const queryParams = new URLSearchParams({
        page: String(page),
        pageSize: String(pageSize),
      });

      Object.entries(filters || {}).forEach(([key, value]) => {
        if (value !== undefined && value !== null && value !== "") {
          queryParams.append(key, value);
        }
      });

      return await BaseService.get(`orders?${queryParams.toString()}`, token, null, config);
    } catch (error) {
      console.error("There was an error fetching the users!", error);
      throw error;
    }
  }
  static async postOrders(userData, token) {
    try {
      return await BaseService.post("orders", userData, token);
    } catch (error) {
      console.error("There was an error posting the user!", error);
      throw error;
    }
  }
  static async editOrders(id, userData, token) {
    try {
      return await BaseService.put("orders", id, userData, token);
    } catch (error) {
      console.error("There was an error editing the user!", error);
      throw error;
    }
  }
  static async editSpecificFieldsOrders(id, userData, token) {
    try {
      return await BaseService.put("orders/specific", id, userData, token);
    } catch (error) {
      console.error("There was an error editing the order!", error);
      throw error;
    }
  }
  static async editOrderStatus(id, data, token) {
    try {
      return await BaseService.put("orders/status", id, data, token);
    } catch (error) {
      console.error("There was an error editing the order status!", error);
      throw error;
    }
  }

  static async deleteOrders(id, token) {
    try {
      return await BaseService.delete("orders", id, token);
    } catch (error) {
      console.error("There was an error deleting the user!", error);
      throw error;
    }
  }

  static async getOrdersToExport(token, startDate, endDate, tennantId, supplierId) {
      try {
        const response = await BaseService.get("orders/export", token, { startDate, endDate, tennantId, supplierId });
        return response.data.data;
      } catch (error) {
        console.log('Status:', error.response?.status);
        console.log('Resposta da API:', error.response?.data);
        console.log('Request:', error.config?.data);
        throw error.response?.data;
      }
    }
}

export default OrderService;
